<!-- eslint-disable vue-a11y/mouse-events-have-key-events -->
<template>
  <div
    class="sam-info-block"
    v-on="$listeners"
  >
    <p
      ref="label"
      class="sam-info-block__label"
    >
      {{ label }}
    </p>
    <p
      :id="valueId"
      ref="value"
      class="sam-info-block__value"
    >
      <span
        v-if="loading"
        class="sam-info-block__loading"
      />
      <template v-else>
        {{ value }}
        <slot name="value-append" />
      </template>
    </p>
  </div>
</template>

<script>
import { uuidv4 } from '../../../utils/utils';

export default {
  name: 'SamInfoBlock',
  props: {
    /**
     * The info block label
     */
    label: {
      type: String,
      required: true,
      default: '',
    },
    /**
     * The info block value
     */
    value: {
      type: String,
      required: true,
      default: '',
    },
    /**
     * Whether to set the info block in a loading state
     */
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    valueId: uuidv4(),
  }),
};
</script>

<style lang="scss" scoped>
.sam-info-block {
  @extend .d-block;
  position: relative;

  &__label {
    @extend .text--caption, .mb-1;
    color: $neutral--80;
  }

  &__value {
    @extend .text--body-2--medium, .text--ellipse, .d-flex, .middle-xs;
    color: $neutral--90;
    width: 100%;
  }

  &__loading {
    display: block;
    height: $size--4;
    width: 75%;
    @include old-skeleton-blink;
  }
}
</style>
